<template>
    <div class="order-detail-section"
         v-if="order.finance && order.finance.plan_pay " v-bind:class="{mg20:!hiddenAction}">
        <h3 v-if="!hiddenAction">回款计划</h3>
        <el-tabs v-model="activeName" style="margin-left: 10px" :class="[oldOrder?'':activeClass]">
            <el-tab-pane name="new">
                <span slot="label" v-if="oldOrder">新修改</span>
                <el-row style="padding:0 30px">
                    <el-col :span="20">
                        <span v-if="order.order_sensitive_masked">
                            <span style="text-align: center;size: 8px">总金额：****** ； </span>
                            <span style="text-align: center;size: 8px;color: #67c23a">实际收款：****** ；</span>
                            <span style="text-align: center;size: 8px;color: #f5222d">未收款：******</span>
                        </span>
                        <span v-else-if="order.finance.total_amount > pay">
                            <span style="text-align: center;size: 8px">总金额：{{order.finance.total_amount}} ； </span>
                            <span style="text-align: center;size: 8px;color: #67c23a">实际收款：{{pay.toFixed(2)}} ；</span>
                            <span style="text-align: center;size: 8px;color: #f5222d">未收款：{{no_pay.toFixed(2)}}</span>
                        </span>
                        <span v-else>
                            <span style="text-align: center;size: 8px;color: #67c23a">已全额到账!</span>
                        </span>
                    </el-col>
                    <el-col :span="4" style="text-align:right">
                        <el-button
                                v-if="order.finance_audit==params.TYPE_CHECKED && Acs('/order/add-pay-log') && !hiddenAction && !order.order_sensitive_masked"
                                size="mini"
                                type="success"
                                :disabled="!order.close_audit==params.TYPE_CHECKED_FAIL"
                                @click="add_pay_log()">
                            录入回款信息
                        </el-button>
                    </el-col>
                </el-row>
                <div class="order-userInfo">
                    <div class="userInfo-wrapper">
                        <el-table :data="order.finance.plan_pay" style="width: 100%">
                            <el-table-column label="期次" >
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ scope.row.no}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="计划回款日期" >
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ scope.row.plan_at}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="计划回款金额">
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ scope.row.plan_amount}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="实际回款日期" >
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ scope.row.actual_at}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="实际回款金额">
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ scope.row.actual_amount}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="最后操作时间">
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ scope.row.updated_at_memo}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作"
                                             v-if="order.finance_audit==params.TYPE_CHECKED && Acs('/order/update-pay-log') && !hiddenAction && !order.order_sensitive_masked">
                                <template slot-scope="scope">
                                    <el-button
                                            size="mini"
                                            type="primary"
                                            :disabled="!order.close_audit==params.TYPE_CHECKED_FAIL"
                                            @click="pay_log(scope.$index, scope.row)">更新
                                    </el-button>
                                    <el-button
                                            size="mini"
                                            type="danger"
                                            :disabled="!order.close_audit==params.TYPE_CHECKED_FAIL"
                                            @click="del_pay_log(scope.row)">清空
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="原来数据" name="old" v-if="oldOrder">
                <span slot="label" style="color: red;">原来数据</span>
                <el-row style="padding:0 30px">
                    <el-col :span="20">
                        <span v-if="order.order_sensitive_masked || oldOrder.order_sensitive_masked">
                            <span style="text-align: center;size: 8px">总金额：****** ； </span>
                            <span style="text-align: center;size: 8px;color: #67c23a">实际收款：****** ；</span>
                            <span style="text-align: center;size: 8px;color: #f5222d">未收款：******</span>
                        </span>
                        <span v-else-if="oldOrder.finance.total_amount > pay">
                            <span style="text-align: center;size: 8px">总金额：{{oldOrder.finance.total_amount}} ； </span>
                            <span style="text-align: center;size: 8px;color: #67c23a">实际收款：{{pay.toFixed(2)}} ；</span>
                            <span style="text-align: center;size: 8px;color: #f5222d">未收款：{{no_pay.toFixed(2)}}</span>
                        </span>
                        <span v-else>
                            <span style="text-align: center;size: 8px;color: #67c23a">已全额到账!</span>
                        </span>
                    </el-col>
                </el-row>
                <div class="order-userInfo">
                    <div class="userInfo-wrapper">
                        <el-table :data="oldOrder.finance.plan_pay" style="width: 100%">
                            <el-table-column label="期次" >
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ scope.row.no}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="计划回款日期">
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ scope.row.plan_at}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="计划回款金额">
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ scope.row.plan_amount}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="实际回款日期">
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ scope.row.actual_at}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="实际回款金额" >
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ scope.row.actual_amount}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>


        <el-dialog :title="pay_log_title" center :visible="pay_log_show" width="30%"
                   :before-close="handleClose">
            <el-form :inline="true" :model="pay_log_item" ref="paylog" :rules="pay_rule">
                <el-form-item prop="actual_at" label="实际回款日期">
                    <div class="block">
                        <el-date-picker
                                value-format="yyyy-MM-dd"
                                        v-model="pay_log_item.actual_at"
                                        type="date" placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </el-form-item>
                <el-form-item prop="actual_amount" label="实际回款金额">
                    <el-input v-model="pay_log_item.actual_amount"
                              :inline-message=true></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="pay_log_show=false">取 消</el-button>
                <el-button type="primary" @click="pay_log_save" :loading="loading">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<style scoped>
    .no_tab {
        margin-top: -50px;
    }
</style>
<script>
    import {OrderMixin} from "~/services/OrderMixin";
    import OrderService from "~/services/order";

    export default {
        mixins: [OrderMixin],
        props: {
            order: {
                required: true
            },
            oldOrder: {
                required: false
            },
            hiddenAction: {
                required: false
            }
        },
        data() {
            return {
                activeClass: 'no_tab',
                activeName: 'new',
                pay_log_show: false,
                pay_log_item: {},
                pay_log_title: '更新回款计划',
                plan_pay: [],
                pay: 0,
                no_pay: 0,
                pay_rule: {
                    actual_amount: [
                        {
                            validator: (rule, value, callback) => {
                                var is_money = /^[0-9]+|[0-9]+[\.][0-9]{0,3}$/;
                                if (!is_money.test(value)) {
                                    callback(new Error("回款金额必须为数字"));
                                }
                                if (value < 0) {
                                    callback(new Error("回款金额必须为正数"));
                                }
                                let total_amount = parseFloat(this.orderData.total_amount);
                                if (parseFloat(value) > total_amount) {
                                    callback(new Error("回款金额不能大于订单总金额:" + total_amount));
                                }
                                callback();
                            },
                            trigger: 'blur',
                            required: true
                        }
                    ],
                    actual_at: [
                        {
                            validator: (rule, value, callback) => {
                                if (value == '无' || value == null || value == '') {
                                    callback(new Error("实际回款日期不能为空"));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'blur',
                            required: true
                        }
                    ],
                    is_draw_bill: [
                        {
                            trigger: 'blur',
                            required: true,
                            message: "请选择是否开票"
                        }

                    ]
                },
                loading: false
            }
        },
        watch: {
            order(value, oldValue) {
                this.already_pay();
            }
        },
        mounted() {
            this.$nextTick(function () {
                this.already_pay();
            })
        },
        methods: {
            already_pay() {
                if (this.order.order_sensitive_masked) {
                    this.pay = 0;
                    this.no_pay = 0;
                    return;
                }
                if (this.order.finance && typeof this.order.finance.plan_pay != 'undefined') {
                    this.pay = 0;
                    this.no_pay = 0;
                    this.plan_pay = this.order.finance.plan_pay;
                    this.plan_pay = this.plan_pay.map((item, index) => {
                        this.pay += item['actual_amount'] ? parseFloat(item['actual_amount']) : 0
                        item.no = index + 1;
                        return item;
                    })
                    this.no_pay = parseFloat(this.order.finance['total_amount']) - parseFloat(this.pay);
                }
            },
            /** 回款计划更新 只有财务才有权限，暂时不知道怎么控制这鬼玩意 */
            pay_log(index, row) {
                this.pay_log_title = '更新回款计划';

                if (row.actual_at == '无') {
                    row.actual_at = '';
                }

                this.pay_log_item = row;
                this.pay_log_show = true;
            },
            del_pay_log(row){
                OrderService.deletePayLog(row).then(res=>{
                    if(!res.code){
                        this.$message({
                            message:  '删除成功',
                            type: 'success'
                        });
                        this.getOrder(this.id);
                    }
                });

            },
            /** 录入回款信息 */
            add_pay_log() {
                this.pay_log_item = {};
                this.pay_log_title = '录入回款信息'
                this.pay_log_show = true;
            },
            handleClose() {
                this.pay_log_show = false;
            },
            /**保存更新操作 */
            pay_log_save() {
                this.$refs['paylog'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.loading = true;
                    let Promise = {};
                    if (!this.pay_log_item.id) {
                        this.pay_log_item.user_id = this.$store.getters.userId;
                        this.pay_log_item.order_id = this.id;
                        this.pay_log_item.customer_id = this.order.customer_id;
                        Promise = OrderService.addPayLog(this.pay_log_item);
                    } else {
                        Promise = OrderService.updatePayLog(this.pay_log_item);
                    }
                    Promise.then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message: this.pay_log_title + '成功',
                                type: 'success'
                            });
                            this.pay_log_show = false;
                            this.getOrder(this.id);
                        }
                        this.loading = false;
                    }).catch(() => {
                        this.loading = false;
                    });
                });

            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_plan_pay.vue